import { useEffect, useRef } from "react";

export interface UseInfiniteScrollProps {
  hasMore: boolean;
  isFetchingMore: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
}

export interface UseInfiniteScrollResult {
  scrollAreaRef: React.RefObject<HTMLDivElement>;
  sentinelRef: React.RefObject<HTMLDivElement>;
}

export function useInfiniteScroll({
  hasMore,
  isFetchingMore,
  onLoadMore,
  rootMargin = "100px",
}: UseInfiniteScrollProps): UseInfiniteScrollResult {
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !hasMore || isFetchingMore) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        if (entries[0].isIntersecting) {
          onLoadMore();
        }
      },
      { root: scrollAreaRef.current, rootMargin },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, isFetchingMore, onLoadMore, rootMargin]);

  return { scrollAreaRef, sentinelRef };
}
